import mxgraph from './mxGraphIndex.js';
import { v4 as uuid } from 'uuid';
import { DiagramConstants as dc } from '@/data/constants';

const { mxEvent } = mxgraph;

export default class GraphListeners {
  constructor(graph, instance) {
    this.graph = graph;
    this.instance = instance;
    this.index = instance.index;
    this.editingCell = null;
  }

  handleEditingStarted(sender) {
    this.editingCell = startEditing(sender);
    const editor = this.graph.cellEditor;
    const text = editor.textarea;

    mxEvent.addListener(text, 'blur', () => {
      editor.focusLost();
    });
  }

  updateCells(sender) {
    const { cells } = sender.selectionModel;
    cells.forEach((cell) => {
      this.updateDiagramBlock({ block: cell, index: this.index });
    });
  }

  handleCellConnected(sender, target) {
    cellConnected(target, this.instance.addNewLink, this.index);
  }

  handleLabelChange(sender) {
    const { updateDiagramBlock, index } = this.instance;
    labelChanged({
      sender,
      updateDiagramBlock,
      index,
      editingCell: this.editingCell,
    });
  }

  handleCellsMoved(sender, { properties: { cells } }) {
    cells.forEach((cell) => {
      cell.block.x = cell.geometry.x / dc.UNIT_SIZE;
      cell.block.y = cell.geometry.y / dc.UNIT_SIZE;
    });
  }
}

function labelChanged({ sender, editingCell, updateDiagramBlock, index }) {
  const { textarea } = sender.cellEditor;
  let label = '';
  const f = textarea.innerText
    .replace(/<br>(?=<u>)|<br>(?!<[a-z]*\d*>)|<div>(?=<u>)|<div>(?!<[a-z]*\d*>)/gi, '\n')
    .replace(/(<\/?[a-z]\/?>)/g, '');
  const filteredText = f.replace(/(\d+[a-zA-z]*)/i, (match) => {
    label = match;
    return '';
  });
  let number = null;

  const isBlock = !!editingCell.block.id;
  if (isBlock) {
    const value = filteredText.endsWith(' ')
      ? `${filteredText}<u>${label}</u>`
      : `${filteredText.trim()}<br><u>${label}</u>`;
    editingCell.setValue(value);
  } else {
    const match = label.match(/\d+\w?/);
    number = match ? match[0].toUpperCase() : '';

    if (number.length > 0) {
      editingCell.block.text = `${dc.FIG_TAG_START}FIG. ${number}${dc.FIG_TAG_END}`;
    }

    editingCell.setValue(editingCell.block.text);

    sender.updateCellSize(editingCell);
  }

  updateDiagramBlock({
    block: editingCell,
    index,
    number,
  });
}

function startEditing(sender) {
  const { textarea, editingCell } = sender.cellEditor;
  const figRegex = new RegExp(`${dc.FIG_TAG_START}|${dc.FIG_TAG_END}`, 'g');
  textarea.textContent = editingCell.block.label
    ? `${editingCell.block.text} ${editingCell.block.label}`
    : editingCell.block.text.replace(figRegex, '');
  return editingCell;
}

function cellConnected(target, addNewLink, index) {
  const { edge } = target.properties;
  const uuidRegex = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$';
  if (edge.target) {
    edge.id = edge.id.match(uuidRegex) ? edge.id : uuid();
    addNewLink({ link: edge, index });
  }
}
